import { render, staticRenderFns } from "./UniUploader.vue?vue&type=template&id=58a70ec3&scoped=true&"
import script from "./UniUploader.vue?vue&type=script&lang=js&"
export * from "./UniUploader.vue?vue&type=script&lang=js&"
import style0 from "./UniUploader.vue?vue&type=style&index=0&id=58a70ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a70ec3",
  null
  
)

export default component.exports